import React from "react";
import {Text, TextAs, TextSizes} from "@clockout-dev/design-elements";
import {SEVERITY_BY_LEVEL, SEVERITY_FALLBACK} from "../uploads-simulator.constants";
import styles from "../styles/pills.module.scss";

/**
 * Uppercase severity pill for contradiction rows (`low | medium | high`).
 * Clones the `JourneyStageTag` tone-map pattern: unknown severities fall back
 * to the neutral em-dash entry so a new server value never breaks the table.
 *
 * @param {Object} props
 * @param {string} [props.severity]
 */
function SeverityPill({severity}) {
    const meta = SEVERITY_BY_LEVEL[severity] || SEVERITY_FALLBACK;

    return (
        <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={`${styles.tag} ${styles[`tone_${meta.tone}`]}`}>
            {meta.label}
        </Text>
    );
}

export default SeverityPill;
